(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fixed-side-menu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miram-fixed-side-menu')) {
    class MiramFixedSideMenu extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.miram-fixed-menu__mobile-toggle');
        this.panel = this.querySelector('.miram-fixed-menu__panel');

        this.handleToggle = () => {
          this.setOpen(!this.classList.contains('is-open'));
        };

        this.handleEscape = (event) => {
          if (event.key === 'Escape') this.setOpen(false);
        };

        this.handleLinkClick = (event) => {
          if (event.target.closest('a')) this.setOpen(false);
        };

        if (this.toggle && this.panel) {
          this.toggle.addEventListener('click', this.handleToggle);
          this.panel.addEventListener('click', this.handleLinkClick);
          document.addEventListener('keydown', this.handleEscape);
        }

        this.initializeHomeHeroVisibility();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleToggle);
        this.panel?.removeEventListener('click', this.handleLinkClick);
        document.removeEventListener('keydown', this.handleEscape);
        this.homeHeroObserver?.disconnect();
      }

      initializeHomeHeroVisibility() {
        this.homeHeroObserver?.disconnect();

        const hero = document.querySelector('.miram-fullscreen-hero');

        if (!hero) {
          this.classList.remove('is-hidden-by-home-hero');
          return;
        }

        const updateFromPosition = () => {
          const rect = hero.getBoundingClientRect();
          const heroIsVisible =
            rect.bottom > 0 &&
            rect.top < window.innerHeight;

          this.classList.toggle(
            'is-hidden-by-home-hero',
            heroIsVisible
          );
        };

        /*
         * Se ejecuta inmediatamente para impedir que el menú aparezca
         * brevemente encima de la imagen al cargar la página.
         */
        updateFromPosition();

        this.homeHeroObserver = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle(
              'is-hidden-by-home-hero',
              entry.isIntersecting
            );

            if (entry.isIntersecting) {
              this.setOpen(false);
            }
          },
          {
            root: null,
            threshold: 0
          }
        );

        this.homeHeroObserver.observe(hero);
      }

      setOpen(open) {
        this.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
      }
    }

    customElements.define('miram-fixed-side-menu', MiramFixedSideMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-global-side-menu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miram-fixed-side-menu')) {
    class MiramFixedSideMenu extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.miram-fixed-menu__mobile-toggle');
        this.panel = this.querySelector('.miram-fixed-menu__panel');

        if (!this.toggle || !this.panel) return;

        this.handleToggle = () => {
          this.setOpen(!this.classList.contains('is-open'));
        };

        this.handleEscape = (event) => {
          if (event.key === 'Escape') this.setOpen(false);
        };

        this.handleLinkClick = (event) => {
          if (event.target.closest('a')) this.setOpen(false);
        };

        this.toggle.addEventListener('click', this.handleToggle);
        this.panel.addEventListener('click', this.handleLinkClick);
        document.addEventListener('keydown', this.handleEscape);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleToggle);
        this.panel?.removeEventListener('click', this.handleLinkClick);
        document.removeEventListener('keydown', this.handleEscape);
      }

      setOpen(open) {
        this.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
      }
    }

    customElements.define('miram-fixed-side-menu', MiramFixedSideMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullscreen-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miram-fullscreen-hero-video')) {
    class MiramFullscreenHeroVideo extends HTMLElement {}
    customElements.define('miram-fullscreen-hero-video', MiramFullscreenHeroVideo);
  }

  document
    .querySelectorAll('.miram-fullscreen-hero video')
    .forEach((video) => {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.pause();
      } else {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-trail-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miram-logo-trail-section')) {
    class MiramLogoTrailSection extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('.miram-logo-trail__canvas');
        this.logoSrc = this.dataset.logoSrc || '';
        this.enabled = this.dataset.enabled === 'true' && Boolean(this.logoSrc);
        this.clickOnly = this.dataset.clickOnly === 'true';
        this.enableTouch = this.dataset.enableTouch === 'true';
        this.spacing = Math.max(1, Number.parseFloat(this.dataset.spacing) || 45);
        this.rotation = Math.max(0, Number.parseFloat(this.dataset.rotation) || 0);
        this.scaleVariation = Math.max(
          0,
          Number.parseFloat(this.dataset.scaleVariation) || 0
        );
        this.opacity = Math.min(
          1,
          Math.max(0, Number.parseFloat(this.dataset.opacity) || 1)
        );
        this.maxStamps = Math.max(
          1,
          Number.parseInt(this.dataset.maxStamps, 10) || 80
        );
        this.shouldFade = this.dataset.fade === 'true';
        this.lifetime = Math.max(
          1,
          Number.parseFloat(this.dataset.lifetime) || 5
        );
        this.logoAlt = this.dataset.logoAlt || '';
        this.entryAnimation = this.dataset.entryAnimation || 'pop';
        this.entryDuration = Math.max(
          80,
          Number.parseInt(this.dataset.entryDuration, 10) || 280
        );
        this.prefersReducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;
        this.lastPoint = null;
        this.stamps = [];

        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerLeave = this.handlePointerLeave.bind(this);

        if (!this.enabled || !this.canvas) return;

        this.addEventListener('pointermove', this.handlePointerMove);
        this.addEventListener('pointerdown', this.handlePointerDown);
        this.addEventListener('pointerleave', this.handlePointerLeave);
      }

      disconnectedCallback() {
        this.removeEventListener('pointermove', this.handlePointerMove);
        this.removeEventListener('pointerdown', this.handlePointerDown);
        this.removeEventListener('pointerleave', this.handlePointerLeave);
      }

      handlePointerMove(event) {
        if (this.clickOnly) return;
        if (event.pointerType === 'touch' && !this.enableTouch) return;

        const point = this.getLocalPoint(event);
        if (!point) return;

        if (!this.lastPoint) {
          this.createStamp(point.x, point.y);
          this.lastPoint = point;
          return;
        }

        const deltaX = point.x - this.lastPoint.x;
        const deltaY = point.y - this.lastPoint.y;
        const distance = Math.hypot(deltaX, deltaY);

        if (distance < this.spacing) return;

        const steps = Math.floor(distance / this.spacing);

        for (let index = 1; index <= steps; index += 1) {
          const progress = index / steps;
          const x = this.lastPoint.x + deltaX * progress;
          const y = this.lastPoint.y + deltaY * progress;
          this.createStamp(x, y);
        }

        this.lastPoint = point;
      }

      handlePointerDown(event) {
        if (!this.clickOnly) return;
        if (event.pointerType === 'touch' && !this.enableTouch) return;

        const point = this.getLocalPoint(event);
        if (!point) return;

        this.createStamp(point.x, point.y);
      }

      handlePointerLeave() {
        this.lastPoint = null;
      }

      getLocalPoint(event) {
        const rect = this.getBoundingClientRect();

        if (
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        ) {
          return null;
        }

        return {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top
        };
      }

      createStamp(x, y) {
        const image = document.createElement('img');
        const rotation =
          (Math.random() * 2 - 1) * this.rotation;
        const variation = this.scaleVariation / 100;
        const scale = Math.max(
          0.15,
          1 - variation + Math.random() * variation * 2
        );

        image.className = 'miram-logo-trail__stamp';
        image.src = this.logoSrc;
        image.alt = this.logoAlt;
        image.setAttribute('aria-hidden', 'true');
        image.style.left = `${x}px`;
        image.style.top = `${y}px`;
        image.style.setProperty(
          '--stamp-rotation',
          `${rotation.toFixed(2)}deg`
        );
        image.style.setProperty(
          '--stamp-scale',
          scale.toFixed(3)
        );
        image.style.setProperty(
          '--stamp-lifetime',
          `${this.lifetime}s`
        );

        this.canvas.appendChild(image);
        this.stamps.push(image);

        this.playEntryAnimation(
          image,
          rotation,
          scale
        ).finally(() => {
          if (!this.shouldFade || !image.isConnected) return;

          image.classList.add('is-fading');
          image.addEventListener(
            'animationend',
            () => this.removeStamp(image),
            { once: true }
          );
        });

        while (this.stamps.length > this.maxStamps) {
          const oldest = this.stamps.shift();
          oldest?.remove();
        }
      }

      playEntryAnimation(image, rotation, scale) {
        if (
          this.prefersReducedMotion ||
          this.entryAnimation === 'none' ||
          typeof image.animate !== 'function'
        ) {
          return Promise.resolve();
        }

        const finalTransform =
          `translate(-50%, -50%) rotate(${rotation.toFixed(2)}deg) scale(${scale.toFixed(3)})`;

        let keyframes;

        if (this.entryAnimation === 'soft') {
          keyframes = [
            {
              opacity: 0,
              transform:
                `translate(-50%, -50%) rotate(${rotation.toFixed(2)}deg) scale(${(scale * 0.72).toFixed(3)})`
            },
            {
              opacity: this.opacity,
              transform: finalTransform
            }
          ];
        } else if (this.entryAnimation === 'bounce') {
          keyframes = [
            {
              opacity: 0,
              transform:
                `translate(-50%, -50%) rotate(${rotation.toFixed(2)}deg) scale(${(scale * 0.18).toFixed(3)})`
            },
            {
              opacity: this.opacity,
              transform:
                `translate(-50%, -50%) rotate(${rotation.toFixed(2)}deg) scale(${(scale * 1.16).toFixed(3)})`,
              offset: 0.62
            },
            {
              opacity: this.opacity,
              transform:
                `translate(-50%, -50%) rotate(${rotation.toFixed(2)}deg) scale(${(scale * 0.94).toFixed(3)})`,
              offset: 0.82
            },
            {
              opacity: this.opacity,
              transform: finalTransform
            }
          ];
        } else {
          keyframes = [
            {
              opacity: 0,
              transform:
                `translate(-50%, -50%) rotate(${rotation.toFixed(2)}deg) scale(${(scale * 0.25).toFixed(3)})`
            },
            {
              opacity: this.opacity,
              transform:
                `translate(-50%, -50%) rotate(${rotation.toFixed(2)}deg) scale(${(scale * 1.08).toFixed(3)})`,
              offset: 0.72
            },
            {
              opacity: this.opacity,
              transform: finalTransform
            }
          ];
        }

        const animation = image.animate(
          keyframes,
          {
            duration: this.entryDuration,
            easing:
              this.entryAnimation === 'soft'
                ? 'cubic-bezier(0.22, 1, 0.36, 1)'
                : 'cubic-bezier(0.34, 1.56, 0.64, 1)',
            fill: 'both'
          }
        );

        return animation.finished.catch(() => {});
      }

      removeStamp(stamp) {
        const index = this.stamps.indexOf(stamp);

        if (index >= 0) {
          this.stamps.splice(index, 1);
        }

        stamp.remove();
      }
    }

    customElements.define(
      'miram-logo-trail-section',
      MiramLogoTrailSection
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
